'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const mobileCheck = require('bunsen/helpers/mobileCheck');
const MediaQuery = require('../../../global/components/MediaQuery');
const {queries} = require('../../../global/core/commonjs/screenSize.es');
const css = require('./personalizationStyle.scss');
const ContextComponent = require('../../../global/components/ContextComponent');
const classnames = require('classnames');
const PersonalizationOverlay = require('./PersonalizationOverlay');
const copy = require('./personalizationCopy.json');
const HomepageCarousel = require('../HomepageCarousel');
const tracking = require('../../helpers/tracking.es');
const PersonalizationPanel = require('./PersonalizationPanel');

class Personalization extends ContextComponent {
    constructor() {
        super();

        this.state = {
            currentRecIndex: 0
        };

        this.onRightOverlayClick = this.onRightOverlayClick.bind(this);
        this.onLeftOverlayClick = this.onLeftOverlayClick.bind(this);
    }

    componentDidMount() {
        tracking.trackPersonalizationMount();
    }

    onRightOverlayClick() {
        // We need to check if Ref is not null, since we're using mediaQueries
        // and multiple instances of the carousel with the same props.
        if (this.carouselRef) {
            this.carouselRef._model.nextPage();
            tracking.trackPersonalizationPromoClick();
        }
    }

    onLeftOverlayClick() {
        if (this.carouselRef) {
            this.carouselRef._model.previousPage();
            tracking.trackPersonalizationPromoClick();
        }
    }

    /**
     * Cuts the number of carousel items to 4 for the mobile screen.
     *
     * @param {array} models - personalizations.
     * @returns {array} - personalizations with only first 4 items sliced.
     */
    filterItemsForMobile(models) {
        return models.map(personalization => {
            return {
                ...personalization,
                items: personalization.items.slice(0, 4)
            };
        });
    }

    render() {
        const {props, state} = this;
        const modelsWithItems = props.models.filter(model => model.items.length);
        let leftOverlay;
        let rightOverlay;

        if (!modelsWithItems.length) {
            return null;
        }

        const variant = tracking.getPersonalizationVariant(modelsWithItems[0]);

        const leftOverlayClass = classnames({
            'is-hidden': state.currentRecIndex === 0
        });

        const rightOverlayClass = classnames({
            'is-hidden': state.currentRecIndex === modelsWithItems.length - 1
        });

        const carouselData = {
            carouselRef: carousel => {
                this.carouselRef = carousel;
            },
            useDotsNav: true,
            transitionEffect: 'slide',
            onPageChange: index => {
                this.setState({
                    currentRecIndex: index
                });
            },
            classNames: {
                list: css.carouselListContainer,
                dotControls: css.carouselDotControls,
                item: classnames(css.carouselItem, {
                    [css.isMobile]: props.isMobile
                }),
                dot: 'hero-carousel-dot',
                wrapper: css.carouselWrapper,
                dotCarouselWrapper: css.dotCarouselWrapper
            },
            onDotClick: function () {
                tracking.trackPersonalizationDotClick(variant);
                tracking.trackPersonalizationPromoClick();
            },
            onImpression: tracking.trackPersonalizationImpression,
            customTransformItemStyle: function (index) {
                return {
                    opacity: this._state.page === index ? 1 : 0.3
                };
            }
        };

        leftOverlay = (
            <PersonalizationOverlay
                additionalClassName={leftOverlayClass}
                isLeft
                onClick={this.onLeftOverlayClick}
            />
        );

        rightOverlay = (
            <PersonalizationOverlay
                additionalClassName={rightOverlayClass}
                onClick={this.onRightOverlayClick}
            />
        );

        return (
            <div className="module-has-no-header">
                <div className="personalization-banner">
                    <div className="whiteout-page-width rowFlex">
                        <div className={`${css.container} colXl9 colXs12`}>
                            {leftOverlay}

                            <div className={`h1 center-text personalization-banner-header`}>{copy.title}</div>

                            <MediaQuery query={[queries.xs, queries.sm, queries.md]}>
                                <HomepageCarousel items={this.filterItemsForMobile(modelsWithItems)} itemsPerPage={1.2} {...carouselData} isMobile>
                                    <PersonalizationPanel isMobile />
                                </HomepageCarousel>
                            </MediaQuery>

                            <MediaQuery query={queries.lg}>
                                <HomepageCarousel items={this.filterItemsForMobile(modelsWithItems)} itemWidth={80} {...carouselData} isMobile isCentered>
                                    <PersonalizationPanel isMobile />
                                </HomepageCarousel>
                            </MediaQuery>

                            <MediaQuery query={queries.xl}>
                                <HomepageCarousel items={modelsWithItems} {...carouselData}>
                                    <PersonalizationPanel />
                                </HomepageCarousel>
                            </MediaQuery>

                            {rightOverlay}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Personalization.propTypes = {
    models: PropTypes.array.isRequired
};

Personalization.defaultProps = {
    isMobile: mobileCheck.any()
};

module.exports = Personalization;



// WEBPACK FOOTER //
// ./assets/js/home/components/personalization/index.jsx